<template>
    <form v-on:submit.prevent="handleSubmit();">
        <div class="form-group">
            <div class="row">
                <div class="col-lg-3">
                    <label>Navn</label>
                    <input 
                    type="text" 
                    name="name" 
                    class="form-control" 
                    placeholder="Navn"
                    v-model="student.name">
                </div>
                <div class="col-lg-3">
                    <label>Adresse</label>
                    <input 
                    type="text" 
                    name="address" 
                    class="form-control" 
                    placeholder="Adresse"
                    v-model="student.address">
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-lg-3">
                    <label>By</label>
                    <input 
                    type="text" 
                    name="city" 
                    class="form-control" 
                    placeholder="By"
                    v-model="student.city">
                </div>
                <div class="col-lg-3">
                    <label>Postnummer</label>
                    <input 
                    type="text" 
                    name="zip" 
                    class="form-control" 
                    placeholder="Postnummer"
                    v-model="student.zip">
                </div>
            </div>
        </div>
        <div class="help-text">
            <p class="text-danger" 
            v-for="error of formErrors"
            v-bind:key="error.key"
            >{{ error }}</p>
        </div>
        <div class="row form-group mt-4">
            <div class="col-sm-3">
                <button type="submit" class="btn btn-primary btn-block">
                    <span v-if="isLoading"><div class="loader mx-auto"></div></span>
                    <span v-else>Gem ændringer</span>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    data: function() {
        return {
            student: {
                name: this.$auth.user().name,
                address: this.$auth.user().address,
                city: this.$auth.user().city,
                zip: this.$auth.user().zip,
            },

            formErrors: [],

            isLoading: false,
        }
    },
    
    methods: {
        updateStudent() {
            this.axios.put('auth/user', this.student)
                .then(res => {
                    this.formErrors = [];
                    this.isLoading = false;

                    this.$auth.fetch();

                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'Dine ændringer blev gemt!',
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    let errors = error.response.data.errors;
                    for(var property in errors) {
                        let error = errors[property][0];

                        switch (error) {
                            case "The name field is required.":
                            error = "Feltet navn er påkrævet.";
                            break;

                            case "The address field is required.":
                            error = "Feltet adresse er påkrævet.";
                            break;

                            case "The city field is required.":
                            error = "Feltet by er påkrævet.";
                            break;

                            case "The zip field is required.":
                            error = "Feltet postnummer er påkrævet.";
                            break;

                            case "The zip must be an integer.":
                            error = "Ugyldigt postnummer.";
                            break;
                        };

                        this.formErrors.push(error);
                    }
                });
        },

        handleSubmit() {
            this.formErrors = [];
            this.isLoading = true;

            this.updateStudent();
        }
    }
}
</script>

